import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'

import Select from '../Select'
import { useSelectionSet } from '../../hooks/selection-set-functions'

const SelectProvvedimento = () => {
  const availableProvvedimenti = useSelector(
    state => state.selection.availableProvvedimenti,
  )
  const selectedProvvedimento = useSelector(
    state => state.selection.selectedProvvedimento,
  )

  const { setSelectedProvvedimento } = useSelectionSet()

  const value = availableProvvedimenti?.includes(selectedProvvedimento)
    ? selectedProvvedimento
    : undefined

  const optionLabels = availableProvvedimenti?.map(
    a =>
      [
        { codice: 'risultati-mancanti', label: 'Risultati mancanti' },
        { codice: 'risultati-ritardo', label: 'Risultati inviati in ritardo' },
        { codice: 'referti-mancanti', label: 'Referti mancanti' },
        { codice: 'referti-ritardo', label: 'Referti inviati in ritardo' },
      ]?.find(c => c.codice === a)?.label,
  )

  return (
    <Grid size={{ xs: 12, md: 3 }}>
      <Select
        id='available-provvedimenti'
        label='Provvedimento'
        value={value}
        options={availableProvvedimenti}
        optionLabels={optionLabels}
        disabled={!availableProvvedimenti}
        onChange={setSelectedProvvedimento}
      />
    </Grid>
  )
}

export default SelectProvvedimento
